import { css, cx, useTheme } from '@fable/theme'
import FlexBox from './FlexBox'

interface Props {
  className?: string
  iconStyles?: string
  color?: string
  size?: number
}

export const FableLoader = ({
  className = '',
  iconStyles = '',
  color,
  size = 40,
}: Props) => {
  const { colors } = useTheme()

  const animation = css`
    path {
      opacity: 0.4;
      animation: flicker 1s linear infinite;
    }

    path:nth-child(1) {
      animation-delay: 0.14s;
    }

    path:nth-child(2) {
      animation-delay: 0.28s;
    }

    path:nth-child(3) {
      animation-delay: 0.42s;
    }

    path:nth-child(4) {
      animation-delay: 0.56s;
    }

    path:nth-child(5) {
      animation-delay: 0.7s;
    }

    path:nth-child(6) {
      animation-delay: 0.84s;
    }

    path:nth-child(7) {
      animation-delay: 1s;
    }

    @keyframes flicker {
      from {
        opacity: 1;
      }
      to {
        opacity: 0.4;
      }
    }
  `

  return (
    <FlexBox
      data-testid="fable-loader"
      className={cx(
        css`
          width: ${size}px;
          height: ${size}px;
        `,
        className
      )}
      centerAll
    >
      <svg
        className={cx(
          animation,
          css`
            width: 100%;
            height: 100%;
            transform: translateY(-2px);
          `,
          iconStyles
        )}
        viewBox="0 0 44 24"
        fill="none"
      >
        <path
          d="M15.7066 20.416H0V23.557H15.7066V20.416Z"
          fill={color || colors.uiRoseDark}
        />
        <path
          d="M3.7313 9.63281L2.16064 12.3529L15.7625 20.2053L17.3332 17.4852L3.7313 9.63281Z"
          fill={color || colors.uiPink}
        />
        <path
          d="M12.3554 2.16211L9.63501 3.73259L17.4883 17.333L20.2087 15.7625L12.3554 2.16211Z"
          fill={color || colors.uiRoseLight}
        />
        <path
          d="M23.5603 0H20.4189V15.7048H23.5603V0Z"
          fill={color || colors.uiYellow}
        />
        <path
          d="M31.6246 2.16211L23.7712 15.7625L26.4916 17.333L34.3448 3.7326L31.6246 2.16211Z"
          fill={color || colors.uiGreenLight}
        />
        <path
          d="M40.2458 9.63477L26.6438 17.4872L28.2144 20.2073L41.8164 12.3549L40.2458 9.63477Z"
          fill={color || colors.uiTeal}
        />
        <path
          d="M43.979 20.416H28.2725V23.557H43.979V20.416Z"
          fill={color || colors.uiBlueLight}
        />
      </svg>
    </FlexBox>
  )
}
